<script>
  // "Transfer here" on an outside-scope row (spec-addendum §C): re-home this
  // unit into the reconciliation's branch. It sits beside DecisionControl
  // rather than inside it, because transfer and status are independent axes —
  // a row can be transferred, adjusted, both, or neither (§A1).
  //
  // Sized to DecisionControl's .rd-btn metrics exactly so the two read as one
  // control strip, and tinted blue so a transfer never reads as the green
  // status-adjust.
  export let selected = false;
  export let onToggle;
</script>

<button class="rt-btn" class:selected on:click={onToggle} aria-pressed={selected}>
  <!-- text checkmark, not an FA <i>: dom.watch()'s svg replacement detaches
       nodes Svelte owns and crashes teardown (spec §10) -->
  {selected ? "✓ " : ""}Transfer here
</button>

<style>
  .rt-btn {
    font-size: 0.8125rem;
    line-height: 1.4;
    padding: 0.25rem 0.625rem;
    white-space: nowrap;
    flex: 0 0 auto;
    border-radius: 0.25rem;
    background: #e7f0fb;
    border: 1px solid #9ec5e8;
    color: #0b5ed7;
    font-weight: 600;
  }
  .rt-btn:hover:not(.selected) {
    background: #d6e6f8;
  }
  .rt-btn.selected {
    background: #0d6efd;
    border-color: #0d6efd;
    color: #fff;
  }
</style>
